// 1.0 导入vue核心包
import Vue from 'vue'
// 2.0 导入App.vue的vue对象
import App from './App'
// 3.0 将 vue-route 集成到这个项目中来
import router from './router'

// 导入axios 
import Api from './api/index.js';
Vue.prototype.$api = Api;

import loginApi from './api/login.js';
Vue.prototype.$loginapi = loginApi;

//导入全局js
import './assets/lib/jquery.min.js'
import './assets/lib/less.js/less.min.js'
import './assets/lib/bootstrap/dist/js/bootstrap.js'

// import common from './kits/common.js'
// Vue.prototype.$common = common;



// 6.0 引入全局 css
import './assets/less/base.less'
import './assets/lib/bootstrap/dist/css/bootstrap.min.css'
import './assets/lib/font-awesome/css/font-awesome.min.css'


import gxdd from './assets/js/Css_moudules'
Vue.prototype.$Agentcode = gxdd.Agentcode;

//使用elsementUi
import ElementUI from 'element-ui';
// import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);

//导入全局字体图标
import './assets/iconfont/iconfont.css'

// 7.0 引入vue-resource， 并绑定， 就会自动在Vue实例上注册一个$http对象
import 'mint-ui/lib/style.css';
import mintui from 'mint-ui';
Vue.use(mintui);

import promise from 'es6-promise';
promise.polyfill();
// 8.0 定义一个全局过滤器实现日期的格式化
import moment from 'moment';
Vue.filter('datefmt', function (input, fmtstring) {
  return moment(input).format(fmtstring)
})

// // 10.0 使用图片预览组件
// import VuePreview from 'vue-preview'
// Vue.use(VuePreview)

// import session from './common/sessionMgr.js'

Vue.config.productionTip = false

/* eslint-disable no-new */

window.vue = new Vue({
  el: '#app',
  router,
  store: loginApi.store,
  components: {
    App
  },
  template: '<App/>',

  //监听路由检查登录
  watch: {
    // "$route": 'checkLogin'
  },

  // created() {
  //   this.checkLogin();
  // },

  // methods: {
  //   checkLogin() {
  //     // session.loginCheck();
  //     // if (!window.loginToken) {
  //     //   //window.location.href="#/Login";
  //     //   //this.$router.push('/Login');
  //     //   this.$router.push('/Login');
  //     // }

  //   }
  // },
});
// window.rootVue = app;
// $(window).on("beforeunload", function () {

//   //session.setLoginState(null);
// });



// WEBPACK FOOTER //
// ./src/main.js